import { render, staticRenderFns } from "./OrderableShippingMethodPreview.vue?vue&type=template&id=315fbdde&"
import script from "./OrderableShippingMethodPreview.vue?vue&type=script&lang=ts&"
export * from "./OrderableShippingMethodPreview.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports